import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import BottomInfoSheet from "../info/BottomInfoSheet";

/**
 * ChartBlock
 * - Pass `infoKey` (e.g., "info.respiratoryRate")
 * - `BottomInfoSheet` handles all i18n rendering
 */
export function ChartBlock({ title, infoKey, children, className = "" }) {
  const { t } = useTranslation();
  const [open, setOpen] = useState(false);

  return (
    <div
      className={`relative rounded-xl overflow-hidden flex flex-col gap-2 ${className}`}
    >
      <div className="flex flex-row justify-between items-center">
        <h3 className="font-semibold">{title}</h3>

        {infoKey && (
          <button
            type="button"
            aria-label={t("activity.info", { defaultValue: "More info" })}
            className="p-2 rounded-lg hover:bg-white/5"
            onClick={() => setOpen(true)}
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 -960 960 960"
              className="fill-greyscale-3 h-4 w-auto"
            >
              <path d="M440-280h80v-240h-80zm40-320q17 0 28.5-11.5T520-640t-11.5-28.5T480-680t-28.5 11.5T440-640t11.5 28.5T480-600m0 520q-83 0-156-31.5T197-197t-85.5-127T80-480t31.5-156T197-763t127-85.5T480-880t156 31.5T763-763t85.5 127T880-480t-31.5 156T763-197t-127 85.5T480-80m0-80q134 0 227-93t93-227-93-227-227-93-227 93-93 227 93 227 227 93m0-320"></path>
            </svg>
          </button>
        )}
      </div>

      {children}

      {infoKey && (
        <BottomInfoSheet
          open={open}
          onClose={() => setOpen(false)}
          infoKey={infoKey}
          titleFallback={title}
        />
      )}
    </div>
  );
}
